// OAuth相關翻譯

export const oauth = {
    processingGoogleLogin: '正在處理Google登錄...',
    redirecting: '正在跳轉...'
  };
